import WidgetDeviceList from '@src/components/_shared/WidgetDeviceList';
import useDeviceWidgetConfig from '@src/hooks/devices/useDeviceWidgetConfig';
import { DeviceListContainerProps } from '@src/types/devices/DeviceRow.types';
import { WidgetTypeDeviceList } from '@src/types/Widget';

const DeviceListContainer: React.FC<DeviceListContainerProps> = ({
  deviceId,
  widgetInternalId,
  unitControllerId,
  unitControllerEngineeringId,
  idPrefix,
  sx,
  isUnitScope = true,
}) => {
  const { data: widgetConfig } = useDeviceWidgetConfig<WidgetTypeDeviceList>({
    internalId: widgetInternalId,
    body: {
      sourceDeviceId: deviceId,
      ...(isUnitScope ? { unitControllerId, unitControllerEngineeringId } : {}),
    },
    queryKeys: [deviceId, unitControllerId],
    enabled: !!deviceId && !!unitControllerId,
  });

  if (!widgetConfig) {
    return null;
  }

  return (
    <WidgetDeviceList
      widgetId={`${idPrefix}_${deviceId}_${unitControllerId}`}
      widgetConfig={widgetConfig}
      sx={sx}
      {...(isUnitScope
        ? { unitControllerId, unitControllerEngineeringId }
        : {})}
    />
  );
};

DeviceListContainer.displayName = 'DeviceListContainer';

export default DeviceListContainer;
